import req from "../methods/req"
export const getCustomerList = function ({
    _this,
    data
}) {
    return method.get_list({
        _this,
        url: '/manage/crm.customer/getCustomerList',
        data
    })
}


// 获取统计周期类型
export const getStatisticalPeriodType = function (data) {
    return req({
        url: '/manage/crm.customer/getStatisticalPeriodType',
        ...data
    })
}



// 获取市场类型详情
export const getMarketType = function (data) {
    return req({
        url: '/manage/crm.customer/getMarketType',
        ...data
    })
}




// 保存市场类型
export const saveMarketType = function (data) {
    return req({
        url: '/manage/crm.customer/saveMarketType',
        ...data
    })
}



// 保存客户类别
export const saveCustomerRuleType = function (data) {
    return req({
        url: '/manage/crm.customer/saveCustomerRuleType',
        ...data
    })
}



// 获取客户市场类型与客户类别下拉、客户级别
export const getMarketAndType = function (data) {
    return req({
        url: '/manage/crm.customer/getMarketAndType',
        ...data
    })
}


// 保存客户级别
export const saveCustomerRuleGrade = function (data) {
    return req({
        url: '/manage/crm.customer/saveCustomerRuleGrade',
        ...data
    })
}



// 获取统计周期类型
export const getCustomerRuleGrade = function (data) {
    return req({
        url: '/manage/crm.customer/getCustomerRuleGrade',
        ...data
    })
}


// 保存等级规则
export const saveLevelRule = function (data) {
    return req({
        url: '/manage/crm.customer/saveLevelRule',
        ...data
    })
}


// 获取规则列表
export const getLevelRuleList = function (data) {
    return req({
        url: '/manage/crm.customer/getLevelRuleList',
        ...data
    })
}



// 修改客户等级状态
export const changeLevelRuleStatus = function (data) {
    return req({
        url: '/manage/crm.customer/changeLevelRuleStatus',
        ...data
    })
}


// 删除客户等级
export const deleteLevelRule = function (data) {
    return req({
        url: '/manage/crm.customer/deleteLevelRule',
        ...data
    })
}



// 获取客户等级详情
export const getLevelRuleDetail = function (data) {
    return req({
        url: '/manage/crm.customer/getLevelRuleDetail',
        ...data
    })
}


// 更新客户级别
export const updateCustomerLevel = function (data) {
    return req({
        url: '/manage/crm.customer/updateCustomerLevel',
        ...data
    })
}




// 获取区域
export const getMarketDepartment = function (data) {
    return req({
        url: '/manage/crm.customer/getMarketDepartment',
        ...data
    })
}


// 添加区域
export const saveMarketDepartment = function (data) {
    return req({
        url: '/manage/crm.customer/saveMarketDepartment',
        ...data
    })
}

// 获取客户类别
export const getCustomerRuleType = function (data) {
    return req({
        url: '/manage/crm.customer/getCustomerRuleType',
        ...data
    })
}





